
/****************************************************************************************************************************************************/
/*****************************************************************Number******************************************************************************/
/****************************************************************************************************************************************************/
/**
 * toFixed 修复
 *
 * @param s
 *            保留小数位数 默认保留两位小数 四舍五入
 * @returns
 */
Number.prototype.toFixed = function(n) {
	if(n > 20 || n < 0) {
		throw new RangeError('toFixed() digits argument must be between 0 and 20');
	}
	var number = this;
	if(isNaN(number) || number >= Math.pow(10, 21)) {
		return number.toString();
	}
	if(typeof(n) == 'undefined' || n == 0) {
		return(Math.round(number)).toString();
	}
	var result = number.toString();
	var arr = result.split('.');

	// 整数的情况
	if(arr.length < 2) {
		result += '.';
		for(var i = 0; i < n; i += 1) {
			result += '0';
		}
		return result;
	}

	var integer = arr[0];
	var decimal = arr[1];
	if(decimal.length == n) {
		return result;
	}
	if(decimal.length < n) {
		for(var i = 0; i < n - decimal.length; i += 1) {
			result += '0';
		}
		return result;
	}
	result = integer + '.' + decimal.substr(0, n);
	var last = decimal.substr(n, 1);

	// 四舍五入，转换为整数再处理，避免浮点数精度的损失
	if(parseInt(last, 10) >= 5) {
		var x = Math.pow(10, n);
		result = (Math.round((parseFloat(result) * x)) + 1) / x;
		result = result.toFixed(n);
	}
	return result;
};
/**
 * 判断是否为金钱格式
 */
Number.prototype.isPrice = function() {
	var _keyword = this.toString();
	if(_keyword == "0" || _keyword == "0." || _keyword == "0.0" ||
		_keyword == "0.00") {
		_keyword = "0";
		return true;
	} else {
		var index = _keyword.indexOf("0");
		var length = _keyword.length;
		if(index == 0 && length > 1) { /* 0开头的数字串 */
			var reg = /^[0]{1}[.]{1}[0-9]{1,2}$/;
			return reg.test(_keyword);
		} else { /* 非0开头的数字 */
			var reg = /^[1-9]{1}[0-9]{0,10}[.]{0,1}[0-9]{0,2}$/;
			return reg.test(_keyword);
		}
		return false;
	}
}
/** * 是否为中国大陆的移动电话 ** */
Number.prototype.isPhone = function() {
	return /^1[3|4|5|6|7|8|9]\d{9}$/.test(this);
}
/**
 * 完成将 toChineseNum， 可以将数字转换成中文大写的表示，处理到万级别，例如 12345.toChineseNum()，返回
 * 一万二千三百四十五。
 */
Number.prototype.toChinesNum = function() {
	let num = this;
	let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
	let unit = ["", "十", "百", "千", "万"];
	let getWan = (temp) => {
		let strArr = temp.toString().split("").reverse();
		let newNum = "";
		for(var i = 0; i < strArr.length; i++) {
			newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
		}
		return newNum;
	}
	let overWan = Math.floor(num / 10000);
	let noWan = num % 10000;
	if(noWan.toString().length < 4) noWan = "0" + noWan;
	return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}
/** ************************************************************************************************************************************************* */
/** ***************************************************************String***************************************************************************** */
/** ************************************************************************************************************************************************* */
/** 除去两边空白 * */
String.prototype.trim = function() {
  return this.replace(/^\s+/, '').replace(/\s+$/, '');
}
/** * 时间字符串转时间对象 ** */
String.prototype.toDate = function() {
	var DATE_REGEXP = new RegExp("(\\d{4})-(\\d{2})-(\\d{2})([T\\s](\\d{2}):(\\d{2}):(\\d{2})(\\.(\\d{3}))?)?.*");
	if(DATE_REGEXP.test(this)) {
		this.replace(DATE_REGEXP, function($all, $year, $month, $day, $part1, $hour, $minute, $second, $part2, $milliscond) {
			return new Date($year, $month - 1, $day, $hour || "00", $minute || "00", $second || "00", $milliscond || "00");
		});
	}
	return null;
}

/*
 * 系统中JS的扩展函数
 */
String.prototype.toInt = function() {
	return isNaN(parseInt(this)) ? this.toString() : parseInt(this);
}

String.prototype.replaceAll = function(reallyDo, replaceWith, ignoreCase) {
	if(!RegExp.prototype.isPrototypeOf(reallyDo)) {
		return this.replace(new RegExp(reallyDo, (ignoreCase ? "gi" : "g")), replaceWith);
	} else {
		return this.replace(reallyDo, replaceWith);
	}
}
/** * 是否为电子邮件 ** */
String.prototype.isEmail = function() {
	return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.trim());
}
/** * 是否为中国大陆的移动电话 ** */
String.prototype.isPhone = function() {
	return /^1[3|4|5|6|7|8|9]\d{9}$/.test(this.trim());
}
/**
 * 格式化金额 参数说明： n：保留几位小数
 */
String.prototype.format = function(n) {
	var s = this,
	n = n > -1 && n <= 20 ? n : 2;
	s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
	var l = s.split(".")[0].split("").reverse(),
		r = s.split(".")[1];
	t = "";
	for(i = 0; i < l.length; i++) {
		t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
	}
	return t.split("").reverse().join("") + (r ? "." + r : "");
}
/**
 * 判断是否为金钱格式
 */
String.prototype.isPrice = function() {
	var _keyword = this;
	if(_keyword == "0" || _keyword == "0." || _keyword == "0.0" ||
		_keyword == "0.00") {
		_keyword = "0";
		return true;
	} else {
		var index = _keyword.indexOf("0");
		var length = _keyword.length;
		if(index == 0 && length > 1) { /* 0开头的数字串 */
			var reg = /^[0]{1}[.]{1}[0-9]{1,2}$/;
			return reg.test(_keyword);
		} else { /* 非0开头的数字 */
			var reg = /^[1-9]{1}[0-9]{0,10}[.]{0,1}[0-9]{0,2}$/;
			return reg.test(_keyword);
		}
		return false;
	}
}
/** 将指定的字符串插入到指定的位置后面，索引无效将直接追加到字符串的末尾 **/
String.prototype.insert = function(ofset, subStr) {
	if(ofset < 0 || ofset >= this.length - 1) {
		return this.append(subStr);
	}
	return this.substring(0, ofset + 1) + subStr + this.substring(ofset + 1);
}
/** 检查字符串是否以subStr开头 **/
String.prototype.startWith = function(subStr) {
  if(!subStr || !this){
    return false;
  }
	if(subStr.length > this.length) {
		return false;
	}
	return this.indexOf(subStr) == 0;
}
/** 保留数字 **/
String.prototype.number = function() {
	return this.replace(/[^d]/g, "");
}
/** 保留字母 **/
String.prototype.english = function() {
	return this.replace(/[^A-Za-z]/g, "");
}
/** 保留中文 **/
String.prototype.chinese = function() {
	return this.replace(/[^u4e00-u9fa5uf900-ufa2d]/g, "");
}
/** 从左截取指定长度的字串 **/
String.prototype.left = function(n) {
	return this.slice(0, n);
}
/** 从右截取指定长度的字串 **/
String.prototype.right = function(n) {
	return this.slice(this.length - n);
}
/** 统计指定字符出现的次数 ***/
String.prototype.occurs = function(ch) {
	return this.split(ch).length - 1;
}
/** 获取文件全名   *******/
String.prototype.getFileName = function() {
	var regEx = /^.*\/([^\/\?]*).*$/;
	return this.replace(regEx, '$1');
};
/** 获取文件扩展名   *******/
String.prototype.getExtName = function() {
	var regEx = /^.*\/[^\/]*(\.[^\.\?]*).*$/;
	return this.replace(regEx, '$1');
};
/** ************************************************************************************************************************************************* */
/** ***************************************************************Date***************************************************************************** */
/** ************************************************************************************************************************************************* */
/**
 * 扩展Date格式化
 * @param {String} format 时间格式
 */
Date.prototype.format = function(format) {
	var o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
		"H+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	var week = {
		"0": "\u65e5",
		"1": "\u4e00",
		"2": "\u4e8c",
		"3": "\u4e09",
		"4": "\u56db",
		"5": "\u4e94",
		"6": "\u516d"
	};
	if(/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	if(/(E+)/.test(format)) {
		format = format.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "\u661f\u671f" : "\u5468") : "") + week[this.getDay() + ""]);
	}
	for(var k in o) {
		if(new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return format;
}
/** ************************************************************************************************************************************************* */
/** ***************************************************************Array***************************************************************************** */
/** ************************************************************************************************************************************************* */
Array.prototype.cSort = function(field, type){
	var arr = this;
	var t = type || "asc";
	var fs = !field ? [] : field.split(".");
	return arr.sort(function(x,y){
		var sortX,sortY;
		for(var i in fs){
			if(sortX && sortY){
				sortX = sortX[fs[i]];
				sortY = sortY[fs[i]];
			}else{
				sortX = x[fs[0]];
				sortY = y[fs[0]];
			}
		}
		if (sortX < sortY) {
			return t == 'desc' ? -1 : 1;
		} else if (sortX > sortY) {
			return t == 'desc' ? 1 : -1;
		} else {
			return 0;
		}
	});
};
/** ************************************************************************************************************************************************* */
/** ***************************************************************DOM******************************************************************************* */
/** ************************************************************************************************************************************************* */
/** 获取任意元素距离页面顶部的距离 ***/
HTMLElement.prototype.getElementTop = function(){
	var top = this.offsetTop;
	var cur = this.offsetParent;
	while(cur != null){
		top += cur.offsetTop;
		cur = cur.offsetParent;
	};
	return top;
};
/**
 * 获取元素到文档顶部和最左侧的距离，兼容多种定位
 */
HTMLElement.prototype.offset = function(){
  var dom  = this;
  if(!(dom instanceof HTMLElement)){
    throw "DOM Not Is A HTMLElement";
  }
  var offset = {
    top: dom.offsetTop,
    left: dom.offsetLeft,
    width: dom.clientWidth,
    height: dom.clientHeight,
  }, cur = dom.offsetParent;
  while(cur != null){
  	offset.top += cur.offsetTop;
  	offset.left += cur.offsetLeft;
  	cur = cur.offsetParent;
  };
  return offset;
}
/**
 * 获取元素到浏览器顶部和最左侧的距离，兼容多种定位
 */
HTMLElement.prototype.position = function(body = window){
  if(!(this instanceof HTMLElement)){
    throw "DOM Not Is A HTMLElement";
  }
  var offset = this.offset();
  /**
  * 获取滚动条距离顶端的距离
  * @return {}支持IE6
  */
  var	scroll = function() {
      if (body.pageYOffset) {
        return {
          top: body.pageYOffset,
          left: body.pageXOffset
        }
      }
       if (document.compatMode && document.compatMode != 'BackCompat')  {
         return {
          top: document.documentElement.scrollTop,
          left: document.documentElement.scrollLeft
         }
       }
      return {
        top: document.body.scrollTop,
        left: document.body.scrollLeft
      };
  }();
  offset.top = offset.top - scroll.top;
  offset.left = offset.top - scroll.left;
  return offset;
}
/** ************************************************************************************************************************************************* */
/** ***************************************************************Canvas**************************************************************************** */
/** ************************************************************************************************************************************************* */
/**
 * 圆角矩形
 * @param {Object} x X坐标
 * @param {Object} y Y坐标
 * @param {Object} w 宽高
 * @param {Object} h 高度
 * @param {Object} r 圆角弧度
 */
CanvasRenderingContext2D.prototype.roundRect = function(x, y, w, h, r) {
  var min_size = Math.min(w, h);
  if (r > min_size / 2) r = min_size / 2;
  // 开始绘制
  this.beginPath();
  this.moveTo(x + r, y);
  this.arcTo(x + w, y, x + w, y + h, r);
  this.arcTo(x + w, y + h, x, y + h, r);
  this.arcTo(x, y + h, x, y, r);
  this.arcTo(x, y, x + w, y, r);
  this.closePath();
  return this;
}



// WEBPACK FOOTER //
// ./src/common/prototype.js